import quotesRender from "@/common/const/elementsList/quotesRender.const";
import { ColumnsStrategy, PriceType } from "@/common/types";
import PriceQuoteRating from "@/components/Quotes/PriceQuoteRating/PriceQuoteRating";
import {
  DefaultHeadColumns,
  DefaultTextColumn,
  OptionsCell,
  QuoteStatusCell,
} from "@/components/TableComponents";
import { Tag } from "antd";

const hardwareQuoteLineStrategy: ColumnsStrategy[] = [
  {
    label: <DefaultHeadColumns text="Quote Line ID" key={"Quote Line ID"} />,
    name: "id",
    render: (value: number) => {
      return (
        <DefaultTextColumn
          text={value?.toString()}
          key={value}
          className="py-0"
        />
      );
    },
  },
  {
    label: <DefaultHeadColumns text="Product" key={"product"} />,
    name: "price",
    render: (value: PriceType) => {
      return (
        <OptionsCell
          options={quotesRender}
          value={value?.type}
          key={`${value?.id} + ${value?.type}`}
        />
      );
    },
  },
  {
    label: <DefaultHeadColumns text="Status" key={"Status"} />,
    name: "status",
    render: (value: any, record: any) => (
      <QuoteStatusCell status={value} key={`${record.id}+${value}`} />
    ),
  },
  {
    label: (
      <DefaultHeadColumns
        text="OEM/Manufaturer Name"
        key="OEM/Manufaturer Name"
      />
    ),
    name: "price",

    render: (value: PriceType) => (
      <DefaultTextColumn
        text={value?.manufaturerName?.toString() || "No data"}
        key={`${value?.id} + ${value?.manufaturerName}`}
        className="py-0"
      />
    ),
  },
  {
    label: <DefaultHeadColumns text="Purchase Type" key={"Purchase Type"} />,
    name: "price",
    render: (value: PriceType) => {
      return (
        <DefaultTextColumn
          text={value?.purchaseType?.toString() || "No data"}
          key={`${value?.id} + ${[value?.purchaseType]}`}
          className="py-0"
        />
      );
    },
  },
  {
    label: <DefaultHeadColumns text="Contract Term " key={"Contract Term "} />,
    name: "price",
    render: (value: PriceType) => (
      <DefaultTextColumn
        text={
          value?.contractTerm?.toString()
            ? value?.contractTerm?.toString() + " Months"
            : "No data"
        }
        key={`${value?.id} + ${[value?.contractTerm]}`}
        className="py-0"
      />
    ),
  },
  {
    label: <DefaultHeadColumns text="OTE" key={"OTC"} />,
    name: "price",

    render: (value: PriceType) => (
      <DefaultTextColumn
        text={value?.OTE || 0}
        key={value?.id + "OTE"}
        className="py-0"
        labelClassName="text-primary"
      />
    ),
  },
  {
    label: <DefaultHeadColumns text="MRE" key={"MRC"} />,
    name: "price",
    render: (value: PriceType) => (
      <DefaultTextColumn
        text={value?.MRE || 0}
        key={value?.id + "MRE"}
        className="py-0"
        labelClassName="text-primary"
      />
    ),
  },
  {
    label: <DefaultHeadColumns text="Quote Type" key={"Quote Type"} />,
    name: "quoteType",
    render: (value) => {
      if (value === "Firm") {
        return (
          <Tag
            color="green"
            bordered={false}
            className="font-kanit font-light rounded-full text-[14px] leading-5 px-3.5"
          >
            {value}
          </Tag>
        );
      }
      return (
        <Tag
          color="gold"
          bordered={false}
          className="font-kanit font-light rounded-full text-[14px] leading-5 px-3.5"
        >
          {value}
        </Tag>
      );
    },
  },
  {
    label: "",
    name: "raiting",
    render: (value: string) => (
      <PriceQuoteRating value={value as "L1" | "L2" | "L3" | undefined} />
    ),
  },
];

export default hardwareQuoteLineStrategy;
